module.exports = __webpack_public_path__ + "images/category_lp/watch/assessment_achievements/5_a86dc6b5627285fbe466b024f7955d77.png";